export const __EXTRANET_WRAPPER_WIDTH_PIXELS = 1200
export const __TERMS_OF_USE_LINK = import.meta.env.VITE_TERMS_OF_USE_LINK as string
export const __PRIVACY_POLICY_LINK = import.meta.env.VITE_PRIVACY_POLICY_LINK as string
export const __ORDER_AND_DELIVERY_TERMS_LINK = import.meta.env
  .VITE_ORDER_AND_DELIVERY_TERMS_LINK as string
